import styled from 'styled-components/macro';
import { TabA } from '../../../components/TabStyles';
import { DefaultIcon } from '../../../components/Icon';

export const RequiresActionDiv = styled.div`
  display: flex;
  padding-bottom: 40px;
  align-items: center;
  @media screen and (min-width: 375px) {
    padding-bottom: 35px;
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 1024px) {
    margin-top: 0px;
  }
`;
export const CustomDefaultIcon = styled(DefaultIcon)`
  width: 25px;
  height: 25px;
  @media screen and (min-width: 1024px) {
    width: 32px;
    height: 32px;
  }
`;

export const SummaryFooterP = styled.p`
  font-size: 1.2rem;
  ${props => props.theme.fontStackHeader};
  font-weight: 500;
  @media screen and (min-width: 1024px) {
    font-size: 1.3rem;
  }

  text-transform: uppercase;
  /* padding-bottom: 16px; */
  padding-bottom: 30px;
  /* @media screen and (min-width: 768px) {
  } */
  @media screen and (min-width: 1024px) {
    padding-bottom: 35px;
  }
`;

export const StatusSpan = styled.span`
  text-transform: uppercase;
  font-weight: 500;
  padding-left: 2px;
  color: ${props => props.theme[props.color]};
`;

export const CustomCsvh5 = styled.h5`
  font-weight: 500;
  color: ${props => props.theme[props.color]};
  text-transform: initial;
`;

export const CustomCsvImg = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 5px;
`;

export const CustomCsvA = styled(TabA)`
  display: flex;
  align-items: center;
  padding-right: 0;
`;
